import { Location } from "@angular/common";
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IUserDto } from 'core/dto';
import { pairBehaviorSubjects } from 'core/rx-js';
import { LoaderService } from 'core/services';
import { BehaviorSubject, combineLatest, distinctUntilChanged, map, tap } from 'rxjs';
import { designerPaths } from '../../../designer.paths';

import { UserService } from '../../../global-services/user.service';
import { DsgDeepTranslationKey } from '../../../pipes/translate.pipe';
import { RemoteUserService } from './remotes/remote-user.service';

@Injectable()
export class UserDetailService {

  baseElement: HTMLElement
  tabsHeader: HTMLElement
  header: HTMLElement

  readonly userIdSubject = new BehaviorSubject<string>(undefined);
  get userId() {
    return this.userIdSubject.value;
  }

  readonly userSubject = this._remoteUserService.userSubject;
  get user() {
    return this.userSubject.value;
  }



  readonly loggedInUserSubject = this._userService.userSubject;

  readonly canChangePasswordObs = combineLatest([this.loggedInUserSubject, this.userIdSubject])
    .pipe(
      map(([loggedInUser, userId]) => loggedInUser.id === userId),
      distinctUntilChanged()
    )

  constructor(
    private readonly _remoteUserService: RemoteUserService,
    private readonly _router: Router,
    private readonly _loaderService: LoaderService<DsgDeepTranslationKey>,
    private readonly _location: Location,
    private readonly _userService: UserService
  ) {

    pairBehaviorSubjects(this.userIdSubject, this._remoteUserService.keyValueSubject);

  }


  update(user: IUserDto) {

    return this._remoteUserService.update({ ...this.user, ...user }, 'updateLocal');
  }

  updateUserSplugConfigurations(splugConfigurations: IUserDto['sigConfigs']) {

    return this._remoteUserService.update({ ...this.user, sigConfigs: splugConfigurations }, 'updateLocal')
  }

  insert(user: IUserDto) {
    return this._remoteUserService.insert(user).pipe(
      tap((id) => {
        this._location.replaceState(designerPaths.userManagement + '/' + id);
      })
    )
  }

  saveUser(user: IUserDto) {

    if (this.userId) {
      const id = this._loaderService.show({ key: 'user.save', text: 'ss-entities.user.update.display' })
      return this.update(user)
        .pipe(this._loaderService.disposeLoader(id))
    }

    const id = this._loaderService.show({ key: 'user.save', text: 'ss-entities.user.insert.display' })

    return this.insert({ ...user, sigConfigs: [] })
      .pipe(
        this._loaderService.disposeLoader(id)
      )

  }

  remove() {

    return this._remoteUserService.remove()
      .pipe(tap(() => this._router.navigate(['user-management'])))

  }

  changePassword(password: string) {

    return this._remoteUserService.changePassword(this.userId, password)

  }

  append(element: HTMLElement) {
    const elements = [element, this.header, this.tabsHeader]
    return elements
  }


}
